import { render, staticRenderFns } from "./ProjectsItemCommunicationPlanComponent.vue?vue&type=template&id=ea0200a4&"
import script from "./ProjectsItemCommunicationPlanComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectsItemCommunicationPlanComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsItemCommunicationPlanComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCardTitle,VDialog,VIcon,VSheet})
